module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_wemakeprice_m2.508575885dde22691489cc68f03b4e0c.png";